import React from "react";
import { Button } from "reactstrap";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";

export default class FilterUtility extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: "LIKE",
      input: "",
      input2: "",
    };
  }

  render() {
    return (
      <div style={{ display: "flex" }}>
        {this.props.type === "number" || this.props.type === "text" ? (
          <input
            value={this.state.input}
            onChange={(event) => {
              this.setState({ input: event.target.value });
            }}
            style={{ width: "68%" }}
          />
        ) : this.props.type === "date" ? (
          <DateTime
            value={this.state.input}
            dateFormat={"YYYY-MM-DD"}
            timeFormat={"HH:mm:ss"}
            onChange={(value) => {
              let d;
              if (typeof value === "string") {
                d = "";
              } else {
                d = value.format("YYYY-MM-DD HH:mm:ss");
              }
              this.setState({ input: d });
            }}
          />
        ) : (
          <div>TypeUndefined</div>
        )}
        {this.props.type !== "text" ? (
          <select
            onChange={(event) => {
              this.setState({ dropdown: event.target.value });
            }}
            value={this.state.dropdown}
            style={{ WebkitAppearance: "none", width: "12%" }}
          >
            <option value="LIKE">*</option>
            <option value="=">=</option>
            <option value=">">{">"}</option>
            <option value="<">{"<"}</option>
            <option value=">=">{">="}</option>
            <option value="<=">{"<="}</option>
            <option value="BET">{".."}</option>
          </select>
        ) : null}
        {this.state.dropdown === "BET" ? (
          this.props.type === "number" || this.props.type === "text" ? (
            <input
              value={this.state.input2}
              onChange={(event) => {
                this.setState({ input2: event.target.value });
              }}
              style={{ width: "68%" }}
            />
          ) : this.props.type === "date" ? (
            <DateTime
              value={this.state.input2}
              dateFormat={"YYYY-MM-DD"}
              timeFormat={"HH:mm:ss"}
              onChange={(value) => {
                let d;
                if (typeof value === "string") {
                  d = "";
                } else {
                  d = value.format("YYYY-MM-DD HH:mm:ss");
                }
                this.setState({ input2: d });
              }}
            />
          ) : (
            <div>TypeUndefined</div>
          )
        ) : null}

        <Button
          style={{
            width: "15%",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
          onClick={() => {
            if (this.state.input === "" && this.state.input2 === "") {
              this.props.onChange("");
            } else {
              let filter = `${this.state.dropdown},${this.state.input}`;
              if (this.state.dropdown === "BET") {
                filter = `${filter},${this.state.input2}`;
              }
              if (this.props.type === "number") {
                filter = `${filter},NUM`;
              }
              if (this.props.type === "text") {
                filter = this.state.input;
              }
              this.props.onChange(filter);
            }
          }}
          color={"faiz1"}
        >
          <i className={"fa fa-filter"} style={{ color: "white" }} />
        </Button>
      </div>
    );
  }
}
